import React from 'react'
import { UnderlinedButton } from 'jl-ui-kit/elements/button/Button'
import { SecondaryLink } from 'jl-ui-kit/elements/link/Link'
import auth0 from '../../utils/auth0'
import { getSignInUrl, getInitialScreen } from '../../utils/errors'
import styles from './LinkExpiredError.scss'

type Props = {
  code: string
}

export default function LinkExpiredError({ code }: Props): JSX.Element {
  const title = code.startsWith('reset_password')
    ? 'Reset links expire after 24 hours'
    : 'Sign-in links expire after 1 hour'
  const link = code.startsWith('reset_password')
    ? 'request a new link'
    : 'request a new sign-in link'
  const handleClick = async () => {
    const signInUrl = getSignInUrl()
    try {
      const initialScreen = getInitialScreen(code)
      await auth0().loginWithRedirect({
        initialScreen,
        redirect_uri: `${window.location.origin}/sso/browse/callback`,
      })
    } catch (error) {
      window.location.replace(signInUrl)
    }
  }

  return (
    <div className={styles.container} data-test="link-expired-error">
      <div className={styles.section}>
        <p className={styles.title}>{title}</p>
        <p className={styles.body}>
          Please{' '}
          <UnderlinedButton onClick={handleClick} data-test="request-new-link">
            {link}
          </UnderlinedButton>
        </p>
      </div>

      <div className={styles.section}>
        <p className={styles.title}>Requested more than one link?</p>
        <p className={styles.body}>
          Links expire whenever you request a new one. Make sure you use the most recent one sent to
          you.
        </p>
      </div>

      <div className={styles.cta}>
        <SecondaryLink to="/#homepage" external data-test="error-cta">
          Go to homepage
        </SecondaryLink>
      </div>
    </div>
  )
}
